import { useEffect, useState } from 'react';

import { coinGeckoApi } from '@blockworks/platform/api/coingecko';

const usePriceChart = (slug: string, vsCurrency: string, unixFrom: number, unixTo: number) => {
    const [priceChart, setPriceChart] = useState<any>();

    useEffect(() => {
        if (!slug) {
            return;
        }
        coinGeckoApi.get
            .priceChart({
                slug,
                vsCurrency,
                from: unixFrom,
                to: unixTo,
                coingeckoApiKey: process.env.COINGECKO_API_KEY!,
            })
            .then(res => {
                if (!res) {
                    return;
                }

                setPriceChart(res);
            })
            .catch(e => {
                console.error(e);
            });
    }, [unixFrom, slug, vsCurrency]);

    return priceChart;
};

export { usePriceChart };
